<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'task-analysis-table-2';
const attrs = `border='0' bordercolor='#ffffff'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.task-analysis-table-2 {
  --header-cell-height: 50px;
  --body-cell-height: 45px;
  background-color: var(--theme-color-1);
  thead {
    tr {
      th {
        & > div {
          color: #fff;
        }
      }
      &:first-child {
        th {
          &:first-child,
          &:nth-last-child(2) {
            & > div {
              border-right: 2pt solid #fff;
            }
          }
        }
      }
      &:not(:first-child) {
        th {
          & > div {
            border-top: 2pt solid #fff;
          }
        }
      }
    }
  }
  tbody {
    border-color: var(--theme-color-1-10);
    background-color: var(--theme-color-1-10);
  }
}
</style>
